/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Code_HeadingInputs */

const en_us2_auth_code_heading = /** @type {(inputs: Auth_Code_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your email`)
};

const pt_br2_auth_code_heading = /** @type {(inputs: Auth_Code_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confira seu e-mail`)
};

const es_419_auth_code_heading = /** @type {(inputs: Auth_Code_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa tu email`)
};

const pt_pt2_auth_code_heading = /** @type {(inputs: Auth_Code_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica o teu e-mail`)
};

const fr_fr2_auth_code_heading = /** @type {(inputs: Auth_Code_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consulte tes e-mails`)
};

const de_de2_auth_code_heading = /** @type {(inputs: Auth_Code_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schau in dein Postfach`)
};

const it_it2_auth_code_heading = /** @type {(inputs: Auth_Code_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlla la tua email`)
};

/**
* | output |
* | --- |
* | "Check your email" |
*
* @param {Auth_Code_HeadingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const auth_code_heading = /** @type {((inputs?: Auth_Code_HeadingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Code_HeadingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_auth_code_heading(inputs)
	if (locale === "es-419") return es_419_auth_code_heading(inputs)
	if (locale === "pt-PT") return pt_pt2_auth_code_heading(inputs)
	if (locale === "fr-FR") return fr_fr2_auth_code_heading(inputs)
	if (locale === "de-DE") return de_de2_auth_code_heading(inputs)
	if (locale === "it-IT") return it_it2_auth_code_heading(inputs)
	return en_us2_auth_code_heading(inputs)
});
export { auth_code_heading as "auth.code_heading" }